import React, { useEffect, useState, useRef } from "react";
import UNC from "./ST.mp4";
import RecentList from "./lists/RecentList"
import SerieList from "./lists/SerieList"
import FilmList from "./lists/FilmList"
import MediaBack from "./back/MediaBack";
import { Link } from 'react-router-dom';



function Acceuil() {

    const [back, setBack] = useState({});
    const [showMedias, setShowMedias] = useState(false);
    const backRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/media/list-recents');
                const data = await response.json();

                // Shuffle the data randomly immediately
                const shuffledBack = data.sort(() => Math.random() - 0.5);

                // Pick a random index
                const randomIndex = Math.floor(Math.random() * shuffledBack.length);

                // Use the ref to store the mutable object
                backRef.current = shuffledBack[randomIndex];

                // Add a delay of 5,000ms (5 seconds) before setting the state with shuffled data
                setTimeout(() => {
                    setBack(backRef.current);
                    // Set showMedias to true after 2 seconds
                    setTimeout(() => {
                        setShowMedias(true);
                    }, 1000);
                }, 800);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);


    return (
        <section>
            <div className="screen">
                <div className={`film-back back-home ${showMedias ? "show" : ""}`}>
                    <video muted autoPlay loop className="vid home-back">
                        {back.nom ? (
                            <>
                                <source src={back.bd} type="video/mp4" />
                                <source src={back.bd} type="video/ogg" />
                            </>
                        ) : (
                            <p>Your browser does not support the video tag.</p>
                        )}
                    </video>
                    <h3>{back.nom}</h3>
                    <a href="" className="btn-lecture btn-curved"><img
                    src="https://cdn0.iconfinder.com/data/icons/google-material-design-3-0/48/ic_play_circle_filled_white_48px-512.png"
                    alt=""
                  /></a>
                </div>
            </div>
            <div className="container_news home">
                <h3 className="categorie">Nouveautés</h3>
                <RecentList />
            </div>
            <div className="container_news home">
                <h3 className="categorie">Séries</h3>
                <SerieList />
            </div>
            <div className="container_news home">
                <h3 className="categorie">Films</h3>
                <FilmList />
            </div>
        </section>
    )
}

export default Acceuil;